import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {warningOutline, warningSharp} from "ionicons/icons"

const ListItemButtonUserDisabled: React.FC = () => {

    const
        { t } = useTranslation(),
        [presentAlert] = useIonAlert()

    const alertDataSource = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t('users.alerts.disabled.header'),
            message: t('users.alerts.disabled.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    return (
        <IonButton color="medium" fill="clear"
                   onClick={(e) => alertDataSource(e)}
                   title={t('common.alerts.data_source.header').toString()}>
            <IonIcon color="danger" ios={warningOutline} md={warningSharp} />
        </IonButton>
    )
}

export default ListItemButtonUserDisabled